// Isolated so callers can be tested: jsdom's `window.location.reload` is non-configurable.
export const reloadPage = () => window.location.reload();
